import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import StepContainer from './StepContainer';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Button from 'components/buttons/Button';
import PriceField from 'components/CustomInputs/PriceField';

import FormValidationContent from 'constants/FormValidationContent';
import Preference from 'containers/Preference';
import { CircularProgress } from '@material-ui/core';
import { findFieldByFieldKey } from 'utils';
import Preapproval from 'containers/Preapproval';

const content = {
	en: {
		title: 'How much do you want to spend on a home?',
		next: 'Next',
		previous: 'Previous',
		somethingWentWrong: 'Something went wrong. Please try again later.'
	},
	id: {
		title: 'Berapa harga properti yang ingin Anda beli?',
		next: 'Lanjut',
		previous: 'Kembali',
		somethingWentWrong: 'Terjadi kesalahan. Silakan coba lagi nanti.'
	}
};

const propTypes = {
	showToast: PropTypes.func,
	toNextPage: PropTypes.func,
	toPrevPage: PropTypes.func,
	validationSchema: PropTypes.object
};

const Spend = props => {
	const { toNextPage, toPrevPage, validationSchema, showToast } = props;

	const { state: { languageCode } } = Preference.useContainer();
	const translation = languageCode === 'en' ? content.en : content.id;
	const validationTranslation = languageCode === 'en' ? FormValidationContent.en : FormValidationContent.id;

	const {
		state: {
			form, fields, fieldsUpsert
		},
		upsertFields,
		resetFieldsUpsert
	} = Preapproval.useContainer();

	const { register, handleSubmit, setValue, watch, errors, clearErrors } = useForm({
		resolver: yupResolver(validationSchema)
	});

	const spend = watch('spend');

	useEffect(() => {
		const spend = findFieldByFieldKey(fields, 'spend')?.fieldValue;
		register({ name: 'spend' });
		setValue('spend', spend);
	}, []);

	useEffect(() => {
		if (fieldsUpsert.success) {
			resetFieldsUpsert();
			toNextPage();
		} else if (fieldsUpsert.error) {
			resetFieldsUpsert();
			showToast(translation.somethingWentWrong);
		}
	}, [fieldsUpsert]);

	const onSubmit = data => {
		upsertFields(form.id, [{
			fieldKey: 'spend',
			fieldValue: String(data.spend)
		}]);
	};

	const handlePrev = () => {
		toPrevPage();
	};

	return (
		<div className="spend-preapproval">
			<div className="title">{translation.title}</div>
			<form onSubmit={handleSubmit(onSubmit)}>
				<PriceField
					decimalSeparator={false}
					error={errors.spend ? true : false}
					message={validationTranslation[errors.spend?.message]}
					onValueChange={value => {
						setValue('spend', value.value);
						if (value.value) clearErrors('spend');
						else setValue('spend', undefined);
					}}
					thousandSeparator={'.'}
					value={spend}
				/>
				<div className="buttons">
					<Button onClick={handlePrev} type="button" variant="outlined">
						{translation.previous}
					</Button>
					<Button disabled={fieldsUpsert.loading || !spend || spend < 1}
						type="submit"
						variant="contained"
					>
						{fieldsUpsert.loading? (
							<CircularProgress />
						) : (
							translation.next
						)}
					</Button>
				</div>
			</form>
		</div>
	);
};

Spend.propTypes = propTypes;
export default StepContainer(Spend);
